import { jsxs as r, jsx as e, Fragment as S } from "@emotion/react/jsx-runtime";
import { useId as b, useState as x } from "react";
import { Text as y, Icon as I } from "@partoohub/ui";
import g from "react-phone-number-input/flags";
import { PhoneNumberInputContainer as F, PhoneNumberInputStyled as N, StyledLabel as v, ExplanationText as P } from "./PhoneNumberInput.styled.js";
const j = ({
  value: s,
  onChange: u,
  defaultCountry: l = "FR",
  disabled: n = !1,
  errorMessage: a,
  placeholder: m,
  required: f = !1,
  disableCountrySelect: p = !1
}) => {
  const c = b(), [i, d] = x({
    touched: !1,
    focused: !1
  }), o = !!a, t = !!s || i.focused;
  return /* @__PURE__ */ r("div", { children: [
    /* @__PURE__ */ r(F, { disabled: n, hasError: o, disableCountrySelect: p, children: [
      /* @__PURE__ */ e(N, { defaultCountry: l, flags: g, disabled: n, value: s, onFocus: () => d({
        ...i,
        focused: !0
      }), onBlur: () => d({
        focused: !1,
        touched: !0
      }), onChange: (h) => u(h || ""), id: c }),
      /* @__PURE__ */ r(v, { hasError: o, disabled: n, focused: t, "aria-live": "assertive", htmlFor: c, children: [
        /* @__PURE__ */ e(y, { variant: t ? "bodyXSSemibold" : "bodyMSemibold", as: "span", color: o ? "danger" : "secondary", children: m }),
        /* @__PURE__ */ e("sup", { children: f && /* @__PURE__ */ r(S, { children: [
          " ",
          /* @__PURE__ */ e(I, { icon: ["fa-asterisk"], color: "danger", iconSize: t ? "8px" : "10px" })
        ] }) })
      ] })
    ] }),
    o && /* @__PURE__ */ e(P, { variant: "bodySRegular", color: "danger", children: a })
  ] });
};
j.displayName = "PhoneNumberInput";
export {
  j as PhoneNumberInput
};
